<template>
  <b-container fluid>
    <b-breadcrumb
      class="m-0"
      v-if="pageStatus == '1'"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{ $t("dashboard") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        :to="'/employee-tasks/' + $store.state.selectedTaskType"
        style="text-transform: capitalize"
      >{{ $t(this.$store.state.selectedTaskType.toLowerCase()) }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-breadcrumb
      v-else
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType != '/tasks'"
        to="/goverance/one"
      >{{ $t("manageEmployee") }}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType == '/tasks'"
        :to="$store.state.selectedTaskType"
      >{{ $t("tasks") }}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-else
        :to="$store.state.selectedTaskType"
      >{{ $t("employeeProfile") }}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoading"
      class="text-center"
    />

    <div
      v-else
      class="m-0"
    >
      <!-- && taskStatus !=4  // why usinig tast id?-->
      <b-row v-if="showingIntro && form.isShowFormIntro">
        <b-col
          cols="8"
          offset="2"
        >
          <div class="align-middle my-5">
            <h3>
              {{
                form.formTitle
                  ? form.formTitle[selectedLanguage || "english"]
                  : "No Title"
              }}
            </h3>
            <div style="height: calc(100vh - 375px); overflow: auto">
              <!-- <p v-html="pageIntroText"></p> -->
              <p v-html="sanitizeHtml(
                  form.formIntroText
                    ? form.formIntroText[selectedLanguage || 'english']
                    : 'No Title'
                )"></p>
            </div>

            <b-form-checkbox
              class="text-center my-3"
              v-model="userConsent"
            >{{
              $t("questionnaires.consent")
            }}</b-form-checkbox>
            <b-button
              variant="outline-danger"
              class="mr-2"
              @click="backAction()"
            >{{$t("back")}}</b-button>
            <!--{{$t('questionnaires.backToDashboard')}}-->
            <b-button
              variant="outline-success"
              :disabled="!userConsent"
              class="mr-2"
              @click="onClickProceed()"
            >{{ $t("questionnaires.proceed") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <div v-else>
        <div
          id="exam"
          v-if="startExam"
        >
          <div v-if="showTimer">
            {{ $t("certifications.timeLeft") }}
            <span style="font-size: 40px">
              <strong>{{ examPresentTime }}</strong>
            </span>
          </div>
          <b-row class="mb-4 pt-2">
            <b-col
              cols="3"
              class="pr-0 pl-4"
            >
              <div class="mt-5">
                <div
                  class="first"
                  style="max-width: 15rem !important"
                ></div>
                <div
                  id="talkbubble"
                  style="max-width: 15rem !important"
                >
                  <h1>
                    {{ $t("certifications.question") }}
                    {{ currentQuestionIndex + 1 }}
                  </h1>
                </div>
              </div>
            </b-col>
            <b-col cols="6">
              <b-row>
                <b-card
                  header-class="exam-card-header"
                  class="mb-3"
                  style="height: calc(100vh - 215px); width: 100%"
                >
                  <template v-slot:header>
                    <h3 class="mb-0 text-left">
                      <b-badge variant="dark">Q{{ currentQuestionIndex + 1 }}</b-badge>
                      &nbsp;{{ currentQuestion }}
                    </h3>
                  </template>
                  <div v-if="isImageRequired == 1 && ( imgUrl!= null  && imgUrl != '')" style="margin:15px 0px;">
                    <img v-bind:src=imgUrl alt="image" style="height:250px;" />
                  </div>
                  <div
                    class="text-left animate-slide-from-left"
                    v-if="currentAnswerType == 1"
                  >
                    <b-form-group
                      v-for="(answer, answerIndex) in currentAnswers"
                      :key="answerIndex"
                    >
                      <b-form-radio
                        v-model="selectedRadioAns"
                        :value="answer.answer"
                        @change="
                          setAnswer($event, answerIndex, 'radio'),
                            autoNextQuestion()
                        "
                      >{{ answer.answer[selectedLanguage] }}</b-form-radio>
                    </b-form-group>
                  </div>

                  <!-- for Checkboxes type quiestions -->
                  <div
                    class="text-left animate-slide-from-left"
                    v-if="currentAnswerType == 2"
                  >
                    <b-form-group
                      v-for="(answer, index) in currentAnswers"
                      :key="index"
                    >
                      <b-form-checkbox
                        v-model="selectedCheckboxAns"
                        :value="answer.answer"
                        @change="
                          setAnswer($event, index, 'checkbox'),
                            autoNextQuestion()
                        "
                      >{{ answer.answer[selectedLanguage] }}</b-form-checkbox>
                    </b-form-group>
                  </div>

                  <!-- for Buttons type quiestions -->
                  <b-form-group
                    class="text-left animate-slide-from-left"
                    v-if="currentAnswerType == 3"
                  >
                    <b-button
                      pill
                      :variant="
                        selectedButtonAns == answer.answer
                          ? 'primary'
                          : 'outline-primary'
                      "
                      class="mr-3"
                      v-for="(answer, index) in currentAnswers"
                      :key="index"
                      @click="
                        setAnswer(answer, index, 'button'), autoNextQuestion()
                      "
                    >{{ answer.answer[selectedLanguage] }}</b-button>
                  </b-form-group>
                </b-card>
              </b-row>
              <b-row>
                <b-col
                  class="text-left"
                  cols="5"
                >
                  <div>
                    <b-button-group>
                      <b-button
                        variant="outline-danger"
                        v-b-modal.modal-3
                      >{{$t("cancelBtnText")}}</b-button>
                      <b-button
                        variant="outline-primary"
                        :disabled="inTransistion"
                        v-if="currentQuestionIndex != 0"
                        @click="previousQuestion"
                      >{{ $t("certifications.backToQ")
                        }}{{ currentQuestionIndex }}</b-button>
                    </b-button-group>
                  </div>
                </b-col>
                <b-col cols="2">
                  <span>
                    {{ $t("certifications.viewing") }}
                    <b-badge variant="dark">{{
                      currentQuestionIndex + 1 + "/" + questions.length
                    }}</b-badge>
                  </span>
                </b-col>
                <b-col
                  cols="5"
                  class="text-right"
                >
                  <div>
                    <b-button-group>
                      <b-button
                        :disabled="inTransistion"
                        variant="warning"
                        @click="nextQuestion"
                        v-if="currentQuestionIndex + 1 != questions.length"
                      >{{ $t("certifications.next") }}</b-button>
                      <b-button
                        v-if="currentQuestionIndex + 1 == questions.length"
                        :disabled="inTransistion"
                        variant="outline-success"
                        @click="
                          isAllowBlankAns
                            ? $bvModal.show('modal-1')
                            : onValidateExam()
                        "
                      >{{ $t("certifications.submitAnswers") }}</b-button>
                      <!-- v-b-modal.modal-1 -->
                    </b-button-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="3">
              <h4>{{ $t("certifications.answerOverview") }}</h4>
              <div style="height: calc(100vh - 110px); overflow: auto">
                <b-list-group
                  v-for="(question, index) in selectedAnswersForExams"
                  :key="index"
                >
                  <b-list-group-item class="text-left">
                    <b-badge variant="outline-light">Q{{ index + 1 }}</b-badge>
                    <span class="text-danger float-right">
                      <b-badge
                        v-if="currentQuestionIndex >= index || question.viewed"
                        class="mr-2"
                        variant="primary"
                      >{{ $t("certifications.viewed") }}</b-badge>
                      <b-badge
                      style="font-size:10px;"
                      v-if="question.question && question.question.questionAnswerInputType == 2 && question.answer.length || 
                      question.question && question.question.questionAnswerInputType == 1 && question.answer"
                      variant="dark"
                      >{{ $t("certifications.answered") }}</b-badge>
                      <b-badge
                        v-else
                        variant="danger"
                      >{{
                        $t("certifications.notAnswered")
                      }}</b-badge>
                    </span>
                    <span class="text-danger"></span>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </b-col>
          </b-row>
        </div>

        <div
          class="my-5"
          v-else
        >
          <h1 class="mb-3">{{ formTitle }}</h1>
          <p
            v-html="sanitizeHtml(pageIntroText)"
            class="mb-2"
          ></p>

          <p>
            <strong>{{ $t("certifications.guidance") }}</strong>
          </p>
          <p>
            {{ $t("certifications.guidanceText1") }} {{ examTimeLimit }}
            {{ $t("certifications.guidanceText2") }}
          </p>
          <p>
            <strong>{{ $t("certifications.summary") }}</strong>
          </p>
          <p v-if="examTimeLimit > 0">
            {{ $t("certifications.timeLimitText1") }}{{ examTimeLimit }}
            {{ $t("certifications.timeLimitText2") }}
          </p>
          <p v-if="examAttemptsLimit > 0">
            {{ $t("certifications.summaryText1") }} {{ examAttemptsLimit }}
            {{ $t("certifications.summaryText2") }}
          </p>
          <p v-if="isExamUnlimitedAttempts == true || examAttemptsLimit > 0">
            {{ $t("certifications.attemptsToDate") }} {{ examAttemptsToDate }}
          </p>
          <p v-if="examAttemptsLimit > 0">
            {{ $t("certifications.remainingAttempts") }}
            {{
              examAttemptsLimit - examAttemptsToDate >= 0
                ? examAttemptsLimit - examAttemptsToDate
                : 0
            }}
          </p>
          <p
            v-if="examAttemptsLimit - examAttemptsToDate <= 0"
            class="text-danger"
          >
            <span v-if="isExamUnlimitedAttempts == !true">{{ $t("certifications.maximumReach") }}
            </span>
          </p>

          <b-button
            v-if="
              isExamUnlimitedAttempts == true ||
              examAttemptsLimit - examAttemptsToDate > 0
            "
            variant="outline-primary"
            class="mr-2"
            v-b-modal.modal-2
            @click="onTimerSet(true)"
          >{{ $t("certifications.startNow") }}</b-button>

          <!-- to="/my-certifications" -->

          <!-- <b-button
            @click="onBack"
            v-if="
              isExamUnlimitedAttempts == true ||
              examAttemptsLimit - examAttemptsToDate > 0
            "
          >{{ $t("certifications.doLate") }}</b-button> -->
          <b-button
            @click="onBack"
            v-else
          >{{
            $t("certifications.goBack")
          }}</b-button>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :title="$t('certifications.startExam')"
    >
      <p class="my-4">
        {{ $t("certifications.examAboutToStartText1") }} {{ countDown }}
        {{ $t("certifications.examAboutToStartText2") }}
      </p>
      <template v-slot:modal-footer>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="success"
          @click="startExamImmediately"
        >{{
          $t("certifications.startImmediately")
        }}</b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          @click="onTimerSet(false)"
        >{{ $t("certifications.cancel") }}</b-button>
      </template>
    </b-modal>

    <!-- review modal -->
    <b-modal
      id="modal-1"
      size="xl"
      modal-header-close="No"
      :ok-title="$t('certifications.submit')"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      :title="$t('certifications.submitExam')"
      :cancel-title="$t('certifications.cancel')"
      @ok="submitAnswers"
    >
      <p>{{ $t("certifications.aboutToSubmitText") }}</p>
      <p>
        <strong>{{ $t("certifications.note") }}</strong>
        {{ $t("certifications.noteText") }}
      </p>
      <ul v-for="(ans, index) in selectedAnswersForExams" :key="index">
        <li v-if="ans.answer && ans.question.questionAnswerInputType == 2">
          {{ $t("certifications.question") }} {{ index + 1 }}:
          <ul v-for="(ansMulti, indexMulti) in ans.answer" :key="indexMulti">
            <li>
              {{
                ansMulti[selectedLanguage] || $t("certifications.noAnsGiven")
              }}
            </li>
          </ul>
        </li>
        <li v-if="ans.answer && ans.question.questionAnswerInputType == 1">
          {{ $t("certifications.question") }} {{ index + 1 }}:
          {{ ans.answer[selectedLanguage] || $t("certifications.noAnsGiven") }}
        </li>
      </ul>
      <!-- <ul
        v-for="(ans, index) in this.selectedAnswersForExams"
        :key="index"
      >
        <li v-if="ans.answer">
          {{ $t("certifications.question") }} {{ index + 1 }}:
          {{ ans.answer[selectedLanguage] || $t("certifications.noAnsGiven") }}
        </li>
      </ul> -->
    </b-modal>

    <b-modal
      id="modal-3"
      :title="$t('certifications.cancelExam')"
      @ok="onCancelExam"
      :ok-title="$t('okBtnText')"
      :cancel-title="$t('cancelBtnText')"
    >
      <p class="my-4">
        {{ $t("certifications.cancelExamText1") }}
        <span v-if="isExamUnlimitedAttempts == !true">
          {{ $t("certifications.cancelExamText2") }}
          {{ $t("certifications.cancelExamText3") }}
          {{ examAttemptsLimit - examAttemptsToDate }}
          {{ $t("certifications.cancelExamText4") }}
        </span>
      </p>
    </b-modal>

    <!-- modal will show all submited answers -->
    <b-modal
      id="modal-submitted"
      no-close-on-esc
      no-close-on-backdrop
      no-enforce-focus
      hide-header-close
      scrollable
      ok-only
      size="xl"
      :ok-title="$t('certifications.closeText')"
      :title="$t('certifications.examSubmittedText')"
      :cancel-title="$t('certifications.cancel')"
      @hidden="onBack"
    >
      <!-- @hidden="$router.push('/my-certifications')" -->

      <p>{{ $t("certifications.thankYouText") }}</p>
      <p class="text-center">
        <strong>{{ $t("certifications.examResult") }}</strong>
      </p>
      <p>
        {{ $t("certifications.score") }} {{ currentScore }}
        {{ $t("certifications.outOf") }} {{ totalQuestionScore }}
      </p>
      <p>{{ $t("certifications.yourResult") }} {{ examResult }}%</p>
      <p>{{ $t("certifications.toPassExam") }} {{ scoreToPass }}%</p>
      <p v-if="isPassExam">
        {{ $t("certifications.examStatus") }}
        <b-badge variant="success">{{ $t("certifications.pass") }}</b-badge>
      </p>
      <p v-else>
        {{ $t("certifications.examStatus") }}
        <b-badge variant="danger">{{ $t("certifications.fail") }}</b-badge>
      </p>
      <p
        class="text-center"
        v-if="isPassExam"
      >
        <strong>{{ $t("certifications.congrats") }}</strong>
      </p>
      <p
        class="text-center"
        v-else
      >
        <strong>{{ $t("certifications.PlsTryAgain") }}</strong>
      </p>
    </b-modal>

    <!-- invalid modal show -->
    <b-modal
      header-bg-variant="danger"
      id="modal-invalid"
      :title="$t('certifications.alert')"
      :ok-title="$t('certifications.goToQuestion')"
      :cancel-title="$t('certifications.cancel')"
      @ok="onNavigateToInvalidQuestion"
    >
      <p class="text-danger">{{ $t("certifications.blankAns") }}</p>
    </b-modal>
  </b-container>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import AppLoader from "../../components/Loader/Loader";
import _ from "lodash";
import { HTTP } from "../../utils/HTTP";

export default {
  name: "EmployeeUserExam",
  components: {
    AppLoader,
  },
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          to: "/dashboard",
        },
        {
          text: "Forms",
          to: "#",
        },
      ],
      inTransistion: false, // set to true when user selects answer and auto navigates to next question, used to hide or disable buttons
      pageIntroText: null,
      userConsent: 0,
      showingIntro: true,
      formTitle: {},
      startExam: false,
      currentQuestionIndex: 0,
      currentQuestion: null,
      currentAnswers: null,
      currentAnswerType: 1,
      currentExamAttempt: 0,
      enabled: true,
      dragging: false,
      countDown: 10,
      stopTimer: false,
      selected: "english",
      isInvalid: false,
      examTimeLimit: 0,
      examAttemptsToDate: 0,
      examAttemptsLimit: 0,
      isExamUnlimitedAttempts: false,
      selectedAnswers: [],
      questions: [],
      visitedQuestions: [],
      visitedQuestionsAndAnswered: [],
      fromButton: false,

      // stepper functionility
      noOfSteps: 0,
      selectedRadioAns: "",
      selectedCheckboxAns: [],
      selectedButtonAns: "",
      currentScore: 0,
      totalQuestionScore: 0,
      scoreToPass: 0,
      examResult: 0,
      isPassExam: false,

      // exam timer
      examPresentTime: null,
      showTimer: false,
      isAllowBlankAns: false,

      invalidQuestionIndex: null,
      taskId: null,
      pageStatus: null,
      redirectStatus:null,
      parentTaskId:null,
      isAllCorrectMandatory: false,

      // background image
      isImageRequired:false,
      imgUrl:null,

    };
  },
  mounted () {
    this.$store.state.employeeDashboardTabIndex = 0;
    this.taskId = this.$route.params.taskId;
    this.pageStatus = this.$route.params.readOnly;
    let formSchema = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
    let form = formSchema;
    this.form = form;
    this.setUserFormSchemaToStore();
    this.formTitle = form.formTitle[this.selectedLanguage];
    this.formDescription = form.formDescription[this.selectedLanguage];
    this.pageIntroText = form.formIntroText[this.selectedLanguage];
    this.examTimeLimit = form.formConfiguration.exam.examTimeLimit;
    this.scoreToPass = form.formConfiguration.exam.examPassMark;
    this.examAttemptsLimit = form.formConfiguration.exam.examMaxAttempts;
    this.isAllCorrectMandatory = form.formConfiguration.exam.isAllCorrectMandatory || false;
    this.isExamUnlimitedAttempts =
      form.formConfiguration.exam.isUnlimitedAttempts;
    this.isAllowBlankAns = form.formConfiguration.exam.isAllowedEmpty || false;

    if (
      form.formConfiguration.exam.examUniqueAnswersPerAttempt &&
      form.formConfiguration.exam.examUniqueAnswersPerAttempt > 0
    ) {
      this.questions = this.getRandom(
        form.formSection[0].formElements,
        form.formConfiguration.exam.examUniqueAnswersPerAttempt
      );
    } else {
      this.questions = form.formSection[0].formElements;
    }
    

    this.currentQuestion = this.questions[
      this.currentQuestionIndex
    ].questionText[this.selectedLanguage];
    this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
    this.currentAnswerType = this.questions[
      this.currentQuestionIndex
    ].questionAnswerInputType;
    this.noOfSteps = this.questions.length;
    this.examPresentTime = this.examTimeLimit + ":" + 0;

    /* Background Image */
    this.isImageRequired = this.questions[this.currentQuestionIndex].isImageRequired;
    this.imgUrl = this.questions[this.currentQuestionIndex].imgUrl;

    this.setSelectedAnswers();
    this.examAttemptsToDate = parseInt(
      localStorage.getItem( "examAttemptsToDate" )
    );
  },
  beforeDestroy () {
    this.examPresentTime = null;
    this.showTimer = false;
    this.onResetLocalData();
  },

  created () {
    window.stop();
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),
    ...mapState( ["selectedAnswersForExams"] ),
  },

  beforeRouteLeave ( to, from, next ) {
    let employeeIdActive = localStorage.getItem( "employeeId" );
    if(employeeIdActive) {
        let languageInLocalStore =
                localStorage.getItem("formDefaultLanguage") || "english";
            if(languageInLocalStore) {
              this.$store.state.selectedLanguage = languageInLocalStore;
              this.$i18n.locale = languageInLocalStore;
            }
            if ( this.fromButton ) {
              next();
            } else {
              const answer = window.confirm(
                this.$t( "formLeaveAlertMessage" )
              );
              if ( answer ) {
                next();
              } else {
                next( false );
              }
            }
    } else {
      next();
    }
    
  },

  methods: {
    sanitizeHtml,
    ...mapActions( ["setLanguage"] ),
    ...mapMutations( ["UPDATE_FORM"] ),

    leaving () {
      alert( "Leaving..." );
    },

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
    },

    startExamTimer () {
      let presentTime = this.examPresentTime;
      let timeArray = presentTime.split( /[:]+/ );
      let m = timeArray[0];
      let s = this.checkSecond( timeArray[1] - 1 );
      if ( s == 59 ) {
        m = m - 1;
      }

      if ( m < 0 ) {
        this.submitAnswers();
        this.examPresentTime = null;
        this.showTimer = false;
      } else {
        this.examPresentTime = m + ":" + s;
        setTimeout( this.startExamTimer, 1000 );
      }
    },

    checkSecond ( sec ) {
      if ( sec < 10 && sec >= 0 ) {
        sec = "0" + sec;
        if ( sec < 0 ) {
          sec = "59";
        }
        return sec;
      }
    },

    getRandomOld ( arr, numPicks ) {
      var myArray = JSON.parse(JSON.stringify(arr));
      // hold the picked values and their locations
      var pickedValue = new Array( numPicks );
      // size of array
      var arraySize = myArray.length;

      // pick the values
      for (var i = 0; i < numPicks; i++) {
        // choose a random location in the array
        var index = Math.floor( Math.random() * arraySize );

        // get the value and location
        pickedValue[i] = myArray[index];

        // delete the picked value with one from the array
        myArray.splice(index,1);
        
        // decrease the size of the array
        arraySize -= 1;
      }
      return pickedValue;
    },

    getRandom ( arr, n ) {
      var result = new Array( n ),
        len = arr.length,
        taken = new Array( len );
      if ( n > len )
        throw new RangeError( "getRandom: more elements taken than available" );
      while ( n-- ) {
        var x = Math.floor( Math.random() * len );
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     */
    shuffleArray ( array ) {
      for ( var i = array.length - 1; i > 0; i-- ) {
        var j = Math.floor( Math.random() * ( i + 1 ) );
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    setSelectedAnswers () {
      this.$store.state.selectedAnswersForExams = [];
      let allQuestions = _.cloneDeep( this.questions );
      for ( let i = 0; i < allQuestions.length; i++ ) {
        this.selectedAnswersForExams.push( {
          questionIndex: null,
          answer: null,
          answerIndex: null,
          viewed: false,
          question: null,
        } );
      }
    },

    autoNextQuestion () {
      return false;
    },
    backAction () {
      if ( this.pageStatus == "1" ) {
        this.$router.push(
          "/employee-tasks/" + localStorage.getItem( "selected_task_type" )
        );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },
    onClickProceed () {
      this.showingIntro = false;
      this.setUserFormSchemaToStore();
    },
    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      // let taskdata = JSON.parse( localStorage.getItem( "taskFormData" ) );
      this.updateFormToStore( form );
    },

    updateFormToStore ( form ) {
      this.UPDATE_FORM( form );
    },
    startExamImmediately () {
      this.startExam = true;
      if ( this.examTimeLimit && this.examTimeLimit > 0 ) {
        this.showTimer = true;
        setTimeout( this.startExamTimer, 2000 );
      }

      this.$bvModal.hide( "modal-2" );
      let userType = localStorage.getItem( "userType" );
      if ( userType == 1 || userType == 2 ) {
        return;
      } else {
        this.updateAttempt();
      }
    },

    async updateAttempt () {
      /**
       * to logic here to select random questions
       */

      const URI = "api/v1/governance/training/employee/task/exam/attempt",
        headers = {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        };
      const Result = HTTP(
        "post",
        URI,
        { taskId: this.taskId, taskStatus: 1 },
        headers,
        null,
        true
      );
      return Result.then( ( response ) => {
        this.examAttemptsToDate++;

        localStorage.setItem(
          "examAttemptsToDate",
          parseInt( this.examAttemptsToDate )
        );
        localStorage.setItem(
          "examAttemptId",
          parseInt( response.data.attemptId )
        );
      } ).catch( ( err ) => {
        return err;
      } );
    },

    onTimerSet ( value ) {
      if ( value ) {
        this.stopTimer = false;
        this.examStartCountDownTimer();
      } else {
        this.stopTimer = true;
        this.countDown = 10;
        this.$bvModal.hide( "modal-2" );
      }
    },

    examStartCountDownTimer () {
      if ( this.countDown > 0 && !this.stopTimer ) {
        setTimeout( () => {
          this.countDown -= 1;
          this.examStartCountDownTimer();
        }, 1000 );
      }

      if ( this.countDown == 0 ) {
        if ( !this.startExam ) {
          this.startExam = true;
          this.updateAttempt();

          this.$bvModal.hide( "modal-2" );
        }
      }
    },

    setAnswer ( answer, answerIndex, type ) {
      let index = this.currentQuestionIndex;
      if ( type === "radio" ) {
        this.selectedRadioAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if ( type === "checkbox" ) {
        // this.selectedCheckboxAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = this.selectedCheckboxAns;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if ( type === "button" ) {
        this.selectedButtonAns = answer.answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer.answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      this.selectedAnswersForExams[index].viewed = true;
    },

    nextQuestion () {
      if ( this.currentQuestionIndex + 1 < this.questions.length ) {
        this.currentQuestionIndex++;
        this.currentQuestion = this.questions[
          this.currentQuestionIndex
        ].questionText[this.selectedLanguage];
        this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
        this.currentAnswerType = this.questions[
          this.currentQuestionIndex
        ].questionAnswerInputType;

        this.selectedRadioAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
        this.selectedCheckboxAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || [];
        this.selectedButtonAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";

        /* Background Image */
        this.isImageRequired = this.questions[this.currentQuestionIndex].isImageRequired;
        this.imgUrl = this.questions[this.currentQuestionIndex].imgUrl;

      }
    },

      // old method
    // setScoreToAnswer () {
    //   this.currentScore = 0;
    //   this.totalQuestionScore = 0;
    //   let deep = _.cloneDeep( this.selectedAnswersForExams );
    //   deep.map( ( aa ) => {
    //     aa.question &&
    //       aa.question.answers.length &&
    //       aa.question.answers.map( ( ans ) => {
    //         if ( aa.answer === ans.answer && ans.isCorrectAnswer === "Yes" ) {
    //           this.currentScore =
    //             parseInt( this.currentScore ) +
    //             parseInt( aa.question.questionScore );
    //         }
    //       } );
    //   } );
    // },

    setScoreToAnswer() {
      this.currentScore = 0;
      this.totalQuestionScore = 0;
      let foundWrong = null;
      let deep = _.cloneDeep(this.selectedAnswersForExams);
      
      deep.map((selectedQ) => {
        if (selectedQ.question && selectedQ.question.answers.length && selectedQ.question.questionAnswerInputType == 2) {
          for (let q of selectedQ.answer) {
            foundWrong = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "No");
            if (foundWrong) return;
          }
          if (!foundWrong) {
            this.currentScore = parseInt(this.currentScore) + parseInt(selectedQ.question.questionScore);
          }
          
        }
        if (
          selectedQ.question &&
          selectedQ.question.answers.length &&
          selectedQ.question.questionAnswerInputType == 1
        ) {
          selectedQ.question.answers.map((ans) => {
            if (
              selectedQ.answer === ans.answer &&
              ans.isCorrectAnswer === "Yes"
            ) {
              // console.log("ans radios", ans);

              this.currentScore =
                parseInt(this.currentScore) +
                parseInt(selectedQ.question.questionScore);
            }
          });
        }
      });
    },
    setScoreToAnswerForAll(){
      this.currentScore = 0;
      this.totalQuestionScore = 0;
      let foundWrong = null;
      let deep = _.cloneDeep(this.selectedAnswersForExams);
      
      deep.map((selectedQ) => {
        let corectedAnsCount = [];
        let selectedCorectedAnsCount = [];
        if (selectedQ.question && selectedQ.question.answers.length && selectedQ.question.questionAnswerInputType == 2) {
          
          // for all corrected answer must be selected // multi ans nust me selected
              for(let aa of selectedQ.question.answers){
                  if(aa.isCorrectAnswer == "Yes"){
                  corectedAnsCount.push(aa.answer)
                }
               }
              for (let q of selectedQ.answer) {
              let foundYesAns = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "Yes")
                if(foundYesAns){
                  selectedCorectedAnsCount.push(q)
                }
              }


              for (let q of selectedQ.answer) {
                 foundWrong = selectedQ.question.answers.find((item) => item.answer == q && item.isCorrectAnswer == "No");
                  if (foundWrong){
                    return;
                  }else if(corectedAnsCount.length !== selectedCorectedAnsCount.length){
                    foundWrong = null; 
                    return;
                  }
              }
              
              if (!foundWrong) {
               this.currentScore = parseInt(this.currentScore) + parseInt(selectedQ.question.questionScore);
            }          
        }
        if (
          selectedQ.question &&
          selectedQ.question.answers.length &&
          selectedQ.question.questionAnswerInputType == 1
        ) {
          selectedQ.question.answers.map((ans) => {
            if (
              selectedQ.answer === ans.answer &&
              ans.isCorrectAnswer === "Yes"
            ) {
              // console.log("ans radios", ans);

              this.currentScore =
                parseInt(this.currentScore) +
                parseInt(selectedQ.question.questionScore);
            }
          });
        }
      });

    },


    calculateScore() {
      
      if(this.isAllCorrectMandatory){
      this.setScoreToAnswerForAll();
      }else{
      this.setScoreToAnswer();
      }
      this.questions.map((score) => {
        this.totalQuestionScore =
          this.totalQuestionScore + parseInt(score.questionScore);
      });

      let totalScore = this.totalQuestionScore,
        obtainScore = this.currentScore,
        scoreToPass = this.scoreToPass;

      // console.log("obtainScore", obtainScore);
      // console.log("scoreToPass", totalScore);

      let result = (obtainScore / totalScore) * 100;
      this.examResult = Math.round(result);
      // console.log("---this.examResult---", this.examResult);

      this.isPassExam = this.examResult >= scoreToPass ? true : false;
    },
    /*calculateScore () {
      this.setScoreToAnswer();
      this.questions.map( ( score ) => {
        this.totalQuestionScore =
          this.totalQuestionScore + parseInt( score.questionScore );
      } );
      let totalScore = this.totalQuestionScore,
        obtainScore = this.currentScore,
        scoreToPass = this.scoreToPass;

      let result = ( obtainScore / totalScore ) * 100;
      this.examResult = Math.round( result );
      this.isPassExam = this.examResult >= scoreToPass ? true : false;
    },*/

    previousQuestion () {
      this.currentQuestionIndex--;
      this.setAnswer();
      this.currentQuestion = this.questions[
        this.currentQuestionIndex
      ].questionText[this.selectedLanguage];
      this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
      this.currentAnswerType = this.questions[
        this.currentQuestionIndex
      ].questionAnswerInputType;
      this.selectedRadioAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
      this.selectedCheckboxAns = this.selectedAnswersForExams[
        this.currentQuestionIndex
      ].answer || [];
      this.selectedButtonAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";

      /* Background Image */
      this.isImageRequired = this.questions[this.currentQuestionIndex].isImageRequired;
      this.imgUrl = this.questions[this.currentQuestionIndex].imgUrl;

    },

    onBack () {
      if(this.redirectStatus != 1){
        if ( this.pageStatus == "1" ) {
          this.fromButton = true;
          this.$router.push(
            "/employee-tasks/" + this.$store.state.selectedTaskType
          );
        } else {
          this.$router.push( this.$store.state.selectedTaskType );
        }
      }else{
        this.redirectStatus=null;
        /*
        console.log("slide index::"+ localStorage.getItem( "activeSlideIndex" + this.parentTaskId )); 
        */
        localStorage.setItem( "activeSlideIndex" + this.parentTaskId,0);
        this.$router.push("/emplyee-training/" + this.parentTaskId+ "/1");
      }
    },
    tasksPageRoute () {
      if ( this.pageStatus == "1" ) {
        this.$router.push(
          "/employee-tasks/" + this.$store.state.selectedTaskType
        );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },

    onValidateExam() {
      let isValid = false;
      outerLoop: for (let i = 0; i < this.selectedAnswersForExams.length; i++) {
        if (
          this.selectedAnswersForExams[i].question &&
          this.selectedAnswersForExams[i].question.questionAnswerInputType ==
            2 &&
          this.selectedAnswersForExams[i].answer.length < 1
        ) {
          this.invalidQuestionIndex = i;
          isValid = false;
          this.$bvModal.show("modal-invalid");
          break outerLoop;
        }
        else if (!this.selectedAnswersForExams[i].answer) {
          this.invalidQuestionIndex = i;
          isValid = false;
          this.$bvModal.show("modal-invalid");
          break outerLoop;
        }
        isValid = true;
      }
      if (isValid) {
        this.$bvModal.show("modal-1");
      }
    },


    onNavigateToInvalidQuestion() {
      outerLoop: for (let i = 0; i < this.selectedAnswersForExams.length; i++) {
        if (
          this.selectedAnswersForExams[i].question &&
          this.selectedAnswersForExams[i].question.questionAnswerInputType ==
            2 &&
          this.selectedAnswersForExams[i].answer.length < 1
        ) {
          this.currentQuestionIndex = this.invalidQuestionIndex + 1;
          this.previousQuestion();
          break outerLoop;
        }
        else if (!this.selectedAnswersForExams[i].answer) {
          // this.currentQuestionIndex = this.selectedAnswersForExams.length == this.invalidQuestionIndex+1 ? this.invalidQuestionIndex :  this.invalidQuestionIndex+1
          this.currentQuestionIndex = this.invalidQuestionIndex + 1;
          this.previousQuestion();
          break outerLoop;
        }
      }
    },


    submitAnswers ( e ) {
      let taskId = localStorage.getItem( "taskId" );
      let attemptId = localStorage.getItem( "examAttemptId" );
      let userId = localStorage.getItem( "userId" );

      this.calculateScore();
      let examResult = {
        attemptId: attemptId,
        id: taskId,
        totalQuestionScore: this.totalQuestionScore,
        obtainResultAsPercentage: this.examResult,
        examStatus: this.isPassExam,
        userId: userId,
        examAttemptsLimit: this.examAttemptsLimit,
        attmptsRemaining: this.examAttemptsToDate,
        isUnlimitedAttempts: this.isExamUnlimitedAttempts,
      };

      const URI = "api/v1/governance/training/employee/task/submitexam",
        headers = {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        };
      const Result = HTTP(
        "post",
        URI,
        {
          answers: this.selectedAnswersForExams,
          examResult,
          id: taskId,
          attemptId: attemptId,
        },
        headers,
        null,
        true
      );
      return Result.then( ( response ) => {
        if ( e == "only" ) {
          this.fromButton = true;
          this.tasksPageRoute();
        } else {
          this.fromButton = true;
          if(parseInt(response.data.examAttemptsLimit) == parseInt(response.data.examAttempts)){
            if ( response.data.hasOwnProperty( "parentId" ) ) {
              this.redirectStatus = 1;
              this.parentTaskId= response.data.parentId;
            }
          }
          this.$bvModal.show( "modal-submitted" );
        }
      } ).catch( ( err ) => {
        return err;
      } );
    },

    onCancelExam () {
      this.submitAnswers( "only" );
      // this.$router.push("/employee-certifications");
    },
  },
};
</script>

<style>
.exam-card-header {
  padding: 0.75rem 1.25rem !important;
  margin-bottom: 0 !important;
  background-color: rgb(0 0 0 / 3%) !important;
  border-bottom: 1px solid rgb(0 0 0 / 13%) !important;
}
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}
.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}
.animate-slide-to-right {
  position: relative;
  animation: toRight 1s;
  opacity: 1;
}
@keyframes fromLeft {
  from {
    left: -5px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }
  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  background: #33dd97;
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  background: #33dd97;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 6.9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 25px solid #33dd97;
  border-left: 12px solid transparent;
}
</style>
